<template>
  <div v-if="ingressoSelecionado" class="pa-5 w-100">
    <p class="text-h6 primary--text">
      Dados do ingresso: {{ ingressoSelecionado.name }}
    </p>

    <hr>
    <p class="mt-5">
      <strong>Informações do ingresso:</strong>
    </p>

    <p class="mb-1">
      <strong>Produto: </strong>
      <span class="ellipsis nome-produto">{{ ingressoSelecionado.product_name }}</span>
    </p>

    <p class="mb-1">
      <strong>Plano: </strong>
      <span class="ellipsis nome-plano">{{ ingressoSelecionado.plan_name }}</span>
    </p>

    <p class="mb-1">
      <strong>Nome:</strong> {{ ingressoSelecionado.name }}
    </p>

    <p class="mb-1">
      <strong>CPF:</strong> {{ ingressoSelecionado.cnpj_cpf | maskCpfCnpj }}
    </p>

    <p class="mb-1">
      <strong>E-mail:</strong> {{ ingressoSelecionado.email }}
    </p>

    <p class="mb-1">
      <strong>Telefone:</strong> {{ ingressoSelecionado.phone | maskPhone }}
    </p>

    <p class="mb-1">
      <strong>Cargo:</strong> {{ ingressoSelecionado.position }}
    </p>

    <p class="mb-1">
      <strong>Empresa:</strong> {{ ingressoSelecionado.company }}
    </p>

    <v-btn
      v-if="mobile"
      class="mt-2"
      color="primary"
      text
      block
      @click="$emit('cancel')"
    >
      <v-icon>mdi-chevron-left</v-icon> Voltar
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TitularidadeIngressoView',
  filters: {
    maskCpfCnpj(value) {
      if (!value) return '';
      let valor = typeof value !== 'string' ? value.toString() : value;
      if (valor.length === 11) {
        valor = valor.padStart(11, '0');
        valor = valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else {
        valor = valor.padStart(14, '0');
        valor = valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return valor;
    },
    maskPhone(value) {
      if (!value) return '';
      const valor = typeof value !== 'string' ? value.toString() : value;
      return valor.substring(4);
    },
  },
  props: {
    ingressoSelecionado: {
      type: Object,
      default: null,
    },
  },
};

</script>

<style scoped lang="scss">

.nome-produto {
  max-width: calc(100% - 67px);
}

.nome-plano {
  max-width: calc(100% - 49px);
}

@media (min-width: 960px) {
  .nome-produto {
    max-width: 480px;
  }

  .nome-plano {
    max-width: 497px;
  }
}
</style>
